import React, { useState } from 'react';
import {
  LoadingIndicator,
  TableContextProvider,
  TableFooter,
  TablePaginationNew,
  TablePaginationSizeNew,
} from 'lib/components';
import { LandingPageDesignCard } from './LandingPageDesignCard';
import { EmptySearchText, EmptySearchWrapper } from '../styles';
import { PaginationWrapper } from 'app/pages/admin/index.styled';
import { Flex } from 'lib/components/styles/layout';
import { EmptySearchIcon } from '../assets';
import { ILandingPageDesignResponse, LP_BUILDER_MODAL_STEP } from '../types';
import { DEFAULT_DESIGNS_OPTIONS, LpBuilderFormMode } from '../constants';

interface ILandingPageDesignList {
  data: ILandingPageDesignResponse[];
  count: number;
  isLoading: boolean;
  searchQuery: string;
  onPaginationChange: ({
    page,
    size,
  }: {
    page: number;
    size: number;
  }) => Promise<void>;
  page: number;
  limit: number;
  setSelectedTemplateDesignId: React.Dispatch<
    React.SetStateAction<number | null>
  >;
  setStep: React.Dispatch<React.SetStateAction<LP_BUILDER_MODAL_STEP>>;
  batchEditTemplates: ILandingPageDesignResponse[];
  setBatchEditTemplates: React.Dispatch<
    React.SetStateAction<ILandingPageDesignResponse[]>
  >;
  setModalState: React.Dispatch<
    React.SetStateAction<{
      mode: LpBuilderFormMode;
      open: boolean;
    }>
  >;
}

export interface ILpDesignOption {
  value: number;
  label: string;
}

export const LandingPageDesignList = ({
  data,
  count,
  isLoading,
  onPaginationChange,
  page,
  limit,
  searchQuery,
  setSelectedTemplateDesignId,
  setStep,
  batchEditTemplates,
  setBatchEditTemplates,
  setModalState,
}: ILandingPageDesignList) => {
  const [morePopup, setMorePopup] = useState<string | null>(null);
  const togglePopup = (id: string | null) => {
    setMorePopup(prevId => (prevId === id ? null : id));
  };

  return (
    <Flex
      width='100%'
      flexDirection='row'
      gap='24px'
      justifyContent='flex-start'
      flexWrap='wrap'
    >
      {isLoading ? (
        <div>
          <LoadingIndicator isLoading={isLoading} />
        </div>
      ) : (
        <>
          {data.length === 0 ? (
            <>
              <EmptySearchWrapper>
                <EmptySearchIcon />
                <EmptySearchText>
                  {searchQuery?.trim()
                    ? 'Sorry we couldn’t find what you were looking for. Please try again.'
                    : 'There are no designs available.'}
                </EmptySearchText>
              </EmptySearchWrapper>
            </>
          ) : (
            <TableContextProvider
              total={count}
              initPage={page}
              initSize={limit}
              onChange={onPaginationChange}
            >
              {data.map(template => (
                <LandingPageDesignCard
                  key={template.id}
                  landingPageDesign={template}
                  setMorePopup={setMorePopup}
                  morePopup={morePopup}
                  togglePopup={togglePopup}
                  setModalState={setModalState}
                  setSelectedTemplateDesignId={setSelectedTemplateDesignId}
                  setStep={setStep}
                  batchEditTemplates={batchEditTemplates}
                  setBatchEditTemplates={setBatchEditTemplates}
                />
              ))}
              <PaginationWrapper>
                <TableFooter>
                  <TablePaginationNew />
                  <TablePaginationSizeNew
                    text='Show templates:'
                    sizeOptions={DEFAULT_DESIGNS_OPTIONS}
                  />
                </TableFooter>
              </PaginationWrapper>
            </TableContextProvider>
          )}
        </>
      )}
    </Flex>
  );
};
